/**
 * Feb-2026 (User-Wunsch) — Dropdowns merken sich die häufigsten Auswahlen.
 *
 * Pro Dropdown (storageKey) wird die Auswahl-Häufigkeit im localStorage gezählt.
 * `FrequentSelect` nutzt das, um die Top-N zuletzt/häufigst gewählten Optionen
 * unter „★ Häufig verwendet" ganz oben anzuzeigen.
 */
const STORE_KEY = "tw.freq_select.v1";

function readAll() {
    try {
        return JSON.parse(localStorage.getItem(STORE_KEY) || "{}") || {};
    } catch {
        return {};
    }
}

function writeAll(obj) {
    try {
        localStorage.setItem(STORE_KEY, JSON.stringify(obj));
    } catch {
        /* localStorage voll / privat-modus → still ignorieren */
    }
}

/** Zählt eine getroffene Auswahl für `key`/`value` um 1 hoch. */
export function recordSelection(key, value) {
    if (!key || value == null || value === "") return;
    const all = readAll();
    const m = all[key] || {};
    m[value] = (m[value] || 0) + 1;
    all[key] = m;
    writeAll(all);
}

/** Liefert das Häufigkeits-Map { value: count } für `key`. */
export function getFrequency(key) {
    if (!key) return {};
    return readAll()[key] || {};
}
